// extracted by mini-css-extract-plugin
export default {"input":"_6dHs85MNeUYHw91vQ6rl3A==","root":"sSVbCVUUlNBbzolGtcKLgw=="};